/* BellvoLux : petits comportements de l'en-tete et du tiroir panier. JS vanilla. */
(function () {
  document.addEventListener('click', function (e) {
    /* bouton X dans le tiroir de menu mobile */
    var close = e.target.closest('.bl-drawer-head__close');
    if (close) {
      var drawer = close.closest('header-drawer');
      if (drawer && typeof drawer.closeMenuDrawer === 'function') {
        drawer.closeMenuDrawer(e, drawer.querySelector('summary'));
      } else {
        var det = close.closest('details');
        if (det) det.removeAttribute('open');
      }
      return;
    }

    /* bouton « Add » des produits suggeres du tiroir panier */
    var add = e.target.closest('[data-bl-upsell]');
    if (add) {
      e.preventDefault();
      var card = add.closest('.bl-cart__up-card');
      var select = card ? card.querySelector('.bl-cart__up-select') : null;
      var id = parseInt(select ? select.value : add.dataset.blUpsell, 10);
      add.disabled = true;
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble' }),
      })
        .then(function (r) { return r.json(); })
        .then(function (state) {
          var cd = document.querySelector('cart-drawer');
          if (cd && state.sections && typeof cd.renderContents === 'function') {
            state.id = id;
            cd.renderContents(state);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function () { add.disabled = false; });
    }
  });
})();
